import { Directive, ElementRef, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ColorProvider } from '@providers/color/color';
import { Events } from 'ionic-angular';

@Directive({
  selector: '[custom-bg-color]' 
})
export class CustomBgColorDirective implements OnInit, OnChanges {

  @Input('custom-bg-color') options: any;

  constructor(
    private el: ElementRef, 
    private colorProvider: ColorProvider,
    private events: Events
  ) {
  }

  async ngOnInit(): Promise<void> {
    this.update();
    this.events.subscribe('color:updated', () => {
      this.update();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.update();
  }

  replaceAll(str, find, value) {
    const re = new RegExp(find, 'g');

    return str.replace(re, value);
  }

  async update() {
    if(!this.options || !this.options.skip ) {
      const color = await this.colorProvider.getPrimaryColor();

      this.el.nativeElement.style.backgroundColor = color;
  
      if(this.options && this.options.extraCSS) {
  
        const extraCSS = Object.keys(this.options.extraCSS);
  
        for (const property of extraCSS) {
          const value = this.options.extraCSS[property];
          this.el.nativeElement.style[property] = this.replaceAll(value, '{COLOR}', color);
        }
        
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/directives/custom-bg-color/custom-bg-color.ts